import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { OrdersService } from '../services/orders.services';
import * as OrdersActions from './orders.actions';
import { catchError, finalize, map, of, switchMap, tap } from 'rxjs';
import { APIResponse } from 'src/app/core/models/api-response';
import { IQuotation } from '../../quotes/models/quotes.models';
import { QuotesService } from '../../quotes/services/quotes.services';
import { IQuotationDetail } from '../models/quotes.models';

@Injectable()
export class ordersEffects {
  constructor(
    private actions$: Actions,
    public store: Store<AppState>,
    private ordersService: OrdersService
  ) {}

  // fetch All Orders
  // FetchAllOrdersEffect$ = createEffect(() =>
  //     this.actions$.pipe(
  //         ofType(OrdersActions.GetOrders),
  //         switchMap(() =>
  //             this.ordersService.getOrders().pipe(
  //                 map((res: APIResponse<any>) => OrdersActions.GetOrdersSuccess({ Orders: res.data })),
  //                 tap(() => {
  //                     this.store.dispatch(SetLoading({ isAppLoading: false }));
  //                 }),
  //                 catchError(() => of(
  //                     OrdersActions.GetOrdersError()
  //                 ).pipe(
  //                     tap(() => {
  //                         this.store.dispatch(SetLoading({ isAppLoading: false }));
  //                     }))
  //                 )
  //             )
  //         ),
  //         finalize(() => {
  //             this.store.dispatch(SetLoading({ isAppLoading: false }));
  //         })
  //     )
  // );

  getOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrdersActions.GetOrders),
      tap(() => {
        this.store.dispatch(OrdersActions.Loading({ loading: true }));
      }),
      switchMap((action) =>
        this.ordersService
          .getOrders(action.page, action.filter, action.keyword)
          .pipe()
          .pipe(
            map((res: APIResponse<IQuotation>) => OrdersActions.GetOrdersSuccess({ resp: res })),
            catchError((error) => of(OrdersActions.GetOrdersError())),
            finalize(() => {
              this.store.dispatch(OrdersActions.Loading({ loading: false }));
            })
          )
      )
    )
  );

  getOrderById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrdersActions.GetOrderById),
      tap(() => {
        this.store.dispatch(OrdersActions.Loading({ loading: true }));
      }),
      switchMap((action) =>
        this.ordersService
          .getOrderById(action.id)
          .pipe()
          .pipe(
            map((res: APIResponse<IQuotationDetail>) =>
              OrdersActions.GetOrderByIdSuccess({ order: res.object })
            ),
            catchError((error) => of(OrdersActions.GetOrderByIdError())),
            finalize(() => {
              this.store.dispatch(OrdersActions.Loading({ loading: false }));
            })
          )
      )
    )
  );

  sendOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrdersActions.SendOrder),
      switchMap((action) =>
        this.ordersService
          .sendOrderOrRfq(action.data)
          .pipe()
          .pipe(
            map((res: APIResponse<IQuotation>) =>
              OrdersActions.SendOrderSuccess({ order: res.object })
            ),
            catchError((error) => of(OrdersActions.SendOrderFailure()))
          )
      )
    )
  );

  sendRFQ$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrdersActions.SendRFQ),
      switchMap((action) =>
        this.ordersService
          .sendOrderOrRfq(action.data)
          .pipe()
          .pipe(
            map((res: APIResponse<any>) => OrdersActions.SendRFQSuccess({ order: res.object })),
            catchError((error) => of(OrdersActions.SendRFQFailure()))
          )
      )
    )
  );

  updateOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrdersActions.UpdateOrder),
      tap(() => {
        this.store.dispatch(OrdersActions.Loading({ loading: true }));
      }),
      switchMap((action) =>
        this.ordersService.updateOrder(action.orderId, action.updates).pipe(
          map((res: any) => OrdersActions.UpdateOrderSuccess({ order: res.object })),
          catchError((error) => of(OrdersActions.UpdateOrderError())),
          finalize(() => {
            this.store.dispatch(OrdersActions.Loading({ loading: false }));
          })
        )
      )
    )
  );

  Reorder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrdersActions.Reorder),
      switchMap((action) =>
        this.ordersService
          .reorder(action.orderId)
          .pipe()
          .pipe(
            map((res: APIResponse<IQuotationDetail>) =>
              OrdersActions.ReorderSuccess({ order: res.object })
            ),
            catchError((error) => of(OrdersActions.ReorderError()))
          )
      )
    )
  );
}
